import { render, staticRenderFns } from "./TechResume.vue?vue&type=template&id=e89d033e&scoped=true&"
import script from "./TechResume.vue?vue&type=script&lang=js&"
export * from "./TechResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89d033e",
  null
  
)

export default component.exports